// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var GET_DOCUMENT_PASSWORD = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetDocumentPassword($documentId: String!) {\n        get_document_password(document_id: $documentId) {\n            password\n        }\n    }\n"], ["\n    query GetDocumentPassword($documentId: String!) {\n        get_document_password(document_id: $documentId) {\n            password\n        }\n    }\n"])));
var templateObject_1;
